import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { LoginLayoutPage } from './login-layout.page';

const routes: Routes = [
  {
    path: '',
    component: LoginLayoutPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    LoginLayoutPage
  ],
  declarations: [LoginLayoutPage]
})
export class LoginLayoutPageModule {}
